import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AutoManagedReportByInfluencer.graphql';
import { Query, QueryautoManagedReportByInfluencerArgs } from '../../__generated__/globalTypes';

export const useAutoManagedReportByInfluencerQuery = (
  options?: QueryHookOptions<Query, QueryautoManagedReportByInfluencerArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryautoManagedReportByInfluencerArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAutoManagedReportByInfluencerLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryautoManagedReportByInfluencerArgs>
): QueryResult<Query, QueryautoManagedReportByInfluencerArgs> & {
  getAutoManagedReportByInfluencer: LazyQueryExecFunction<Query, QueryautoManagedReportByInfluencerArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAutoManagedReportByInfluencer, result] = useLazyQuery<Query, QueryautoManagedReportByInfluencerArgs>(
    QUERY,
    {
      onError: (error) => {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      },
      ...options
    }
  );

  return { getAutoManagedReportByInfluencer, ...result };
};

export const useAutoManagedReportByInfluencerPromiseQuery = () => {
  const client = useApolloClient();

  const getAutoManagedReportByInfluencer = useCallback(
    (options?: Omit<QueryOptions<QueryautoManagedReportByInfluencerArgs, Query>, 'query'>) =>
      client.query<Query, QueryautoManagedReportByInfluencerArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getAutoManagedReportByInfluencer };
};
// Suspense Query Hooks
export const useAutoManagedReportByInfluencerSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryautoManagedReportByInfluencerArgs>
) => {
  const result = useSuspenseQuery<Query, QueryautoManagedReportByInfluencerArgs>(QUERY, {
    ...options
  });

  return result;
};
